// extracted by mini-css-extract-plugin
export default {"container":"Input_container__ywsgN","text":"Input_text__BMo6N","input":"Input_input__rykXA"};